import React, { useContext, useEffect, useState } from 'react'
import NavBar from './nav-bar'
import NavOverlay from './nav-overlay'
import NavMobile from './nav-mobile'
import AppContext from './context'

const navStyle = {
    top: 0,
    zIndex: 1020
}

export default function Nav() {
    const { setOverlay } = useContext(AppContext)
    const [isProductPage, setIsProductPage] = useState(false)

    const determineIfProductPage = () => {
        try{
            const pathname = window.location.pathname
            const paths = pathname.split('/').filter(x => x !== '')
    
            if(paths.length <= 1) return false
            if(paths[0] !== 'synthesizers') return false
    
            return true
        } catch (e){
            console.log(e)
            return false
        }
    }

    useEffect(() => {
        if(typeof window === 'undefined') return
        setIsProductPage(determineIfProductPage())

        const handleNavigate = () => {
            setOverlay('')
            setIsProductPage(determineIfProductPage())
        }

        window.addEventListener('navigate', handleNavigate)
        return () => window.removeEventListener('navigate', handleNavigate)
    }, [])

    return (
        <nav css={navStyle} style={{ position: isProductPage ? 'relative' : 'sticky', }}>
            <NavBar />
            <NavOverlay />
            <NavMobile />
        </nav>
    )
}
